import * as navigation from 'Navigation';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';

export default class LinkedResultsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: MODEL_NAMES.Results,
      closeable: false,
      preferenceKey: 'linked-results',
    };
  }
}
